@use "../../../sass/global/global" as *;

ux-iws-nb-all-in-one-detail {
    --background-color: #{$color-blue-headline};
    --heading-color: #{$color-white};
    --text-color: #{$color-white};

    --ux-button-text-color: #{$color-white};
    --ux-button-bg-color: #{$color-blue-headline};
    --ux-button-border-color: #{$color-white};
    --ux-button-hover-bg-color: #{$color-blue-headline};
    --ux-button-hover-border-color: #{$color-white};
    --ux-button-hover-text-color: #{$color-blue-1};
    --ux-button-active-bg-color: #{$color-white};
    --ux-button-active-border-color: #{$color-white};
    --ux-button-active-text-color: #{$color-blue-1};
    --ux-button-focus-text-color: #{$color-white};
    --ux-button-focus-border-color: #{$color-white};
}

ux-iws-nb-all-in-one-detail {
    display: none;
    align-items: stretch;
    justify-content: stretch;
    position: relative;
    box-sizing: border-box;
    padding: 0;
    @include font(light);
    background-color: var(--background-color);
    color: var(--text-color);
    width: 100%;
    min-height: 400px;

    * {
        box-sizing: border-box;
    }

    h2,
    h3,
    h4 {
        margin: 0;
        color: inherit;
        @include nb-heading(4, light);
    }

    p {
        @include font(light);
        font-size: 16px;
        line-height: 1.2;
        margin: 0;
        color: inherit;
    }

    p:not(:last-of-type) {
        margin-bottom: 1em;
    }

    .ux-label {
        margin: 0 0 1rem;
        padding: 0;
        line-height: 1.2;
        text-align: left;
        color: inherit;
    }
}

.ux-iws-nb-all-in-one-detail {
    &__inner {
        display: flex;
        flex-flow: row wrap;
        align-items: stretch;
        justify-content: flex-start;
        width: 100%;
    }

    &__image {
        flex: 1 0 auto;
        width: 100%;
        aspect-ratio: 1 / 1;

        img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        @media (min-width: 768px) {
            order: 2;
            width: 50%;
            max-width: 560px;
        }

        @media (min-width: 568px) and (max-width: 767px) {
            aspect-ratio: 3 / 2;
        }

        @media (min-width: 1024px) {
            width: 25%;
            max-width: 560px;
        }
    }

    &__content {
        flex: 1 0 auto;
        position: relative;
        padding: 30px;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: stretch;
        width: 100%;

        @media (min-width: 768px) {
            order: 1;
            width: 50%;
        }
    }

    &__title,
    &__text {
        @include font(light);
        line-height: 1.2;
        margin: 0 0 30px;
        max-width: 800px;

        @media (min-width: 1024px) {
            margin-bottom: 60px;
        }
    }

    &__title {
        font-size: 20px;
    }

    &__text {
        font-size: 1rem;
    }

    &__cta {
        display: flex;
        flex-flow: row nowrap;
        align-items: flex-start;
        justify-content: flex-start;
        width: 100%;
    }
}

ux-iws-nb-all-in-one-detail[active]:not([active="false"]) {
    display: flex;
}
